import React, { useEffect, useState } from 'react';
import './UserDashboard.css';
import { Link } from 'react-router-dom';
import support from './Images/support.png';
import checkout from './Images/checkout.png';
import dollar from './Images/dollar-sign.png';
import "./UserDashboardMenu.css";
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';

const UserDashboardMenu = () => {
    const [orders, setOrders] = useState([]);
    const [user] = useAuthState(auth);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/orders`)
            .then((res) => res.json())
            .then((info) => setOrders(info));
    }, []);

    const paidOrders = orders.filter(order => order.paymentStatus === 'Paid' && order.customerEmail === user?.email);
    const totalSpent = paidOrders.reduce((total, order) => total + parseFloat(order.packagePrice), 0);

    return (
        <div className='container'>
            <div className='row justify-content-center mt-5 mb-5'>
                {/* My Orders */}
                <div className='single-card d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                    <Link to='/my-order'>
                        <div className='icon-img'>
                            <img src={checkout} alt="Checkout Icon" />
                        </div>
                        <p>My Orders</p>
                    </Link>
                </div>
                
                {/* Total Spent */}
                <div className='single-card d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                    <Link to='/'>
                        <div className='icon-img'>
                            <img src={dollar} alt="Dollar Sign Icon" />
                        </div>
                        <p>Total Spent ${totalSpent.toFixed(2)}</p>
                    </Link>
                </div>
                
                {/* Support */}
                <div className='single-card d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                    <Link to='/support'>
                        <div className='icon-img'>
                            <img src={support} alt="Support Icon" />
                        </div>
                        <p>Support</p>
                    </Link>
                </div>
                
                {/* Edit Profile */}
                {/* <div className='single-card d-flex justify-content-center col-lg-3 col-md-5 col-sm-10'>
                    <Link to={`/update-profile/${user?.uid}`}>
                        <div className='icon-img'>
                            <img src={support} alt="Support Icon" />
                        </div>
                        <p>Edit Profile</p>
                    </Link>
                </div> */}
            </div>
        </div>
    );
};

export default UserDashboardMenu;
